// extracted by mini-css-extract-plugin
module.exports = {"productList":"productList_productList__y1sh7","fadeIn":"productList_fadeIn__WvEbc","feedback":"productList_feedback__T2ZLd","closeIcon":"productList_closeIcon__QkAoJ"};